import { ElMessage } from 'element-plus';
import { $t } from '@/plugins/i18n';
import { useMultiTagsStoreHook } from '@/store/modules/multiTags';
import { delAliveRoutes } from '@/router/utils';

/**
 * 延迟执行一个函数，直到指定毫秒数
 * @param {*} fn
 * @param {*} delay
 * @returns
 */
export const interfaceWaitHandle = (fn, delay = 1000) => {
  return window.setTimeout(fn, delay);
};
/**
 * 延迟执行函数
 */
export const debounce = (fn, delay) => {
  let timer;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
};
export const nameToUpperCase = name => {
  return name.charAt(0).toUpperCase() + name.substr(1);
};

// 字典解析
export const dictFilter = (v, dict) => {
  return (dict.find(item => item.value + '' === v + '') || {}).label || '--';
};

/*
 * @Description: 变量类型判断
 */
export const getObjType = obj => {
  const toString = Object.prototype.toString;
  const map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  };
  if (obj instanceof Element) {
    return 'element';
  }
  return map[toString.call(obj)];
};

export const avueSearchOrBtnHide = {
  searchBtn: false,
  addBtn: false,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  searchShowBtn: false,
  refreshBtn: false,
  filterBtn: false,
  excelBtn: false,
  columnBtn: false,
  index: true
};

/**
 *
 * @param {*} path 图片path
 * @returns 返回图片url和PathFileList
 */
export const getUrlAndPathFileList = path => {
  const str = path.includes('path') ? path.substring(0, path.length - 4) : path;
  return [str + 'Url', str + 'List'];
};

/**
 *
 * @param {*} 点击复制密码
 * @returns 返回图片url和PathFileList
 */
export const rightClick = password => {
  const url = password;
  const oInput = document.createElement('input');
  oInput.value = url;
  document.body.appendChild(oInput);
  oInput.select();
  document.execCommand('Copy');
  ElMessage({
    message: $t('已成功复制到剪切板'),
    type: 'success'
  });
  oInput.remove();
};

// 是否有重复的Dict
export const jugeSameDict = list => {
  let flag = false;
  const dicCodeList = [];
  list.forEach(item => {
    item.code && dicCodeList.push(item.code);
    item.name && dicCodeList.push(item.name);
  });
  const hash = {};
  for (const i in dicCodeList) {
    if (hash[dicCodeList[i]]) flag = true;
    hash[dicCodeList[i]] = true;
  }
  return flag;
};

/**
 * 1、校验区间开始时间不能大于结束时间
 * 2、查询区间限制
 * 3、校验开始、结束时间是否为必填项
 * @param {*} params 参数
 * @param {*} checkTimes 校验的时间集合
 * {
 * startTime  开始时间
 * endTime  结束时间
 * msg  开始大于结束时间错误提示
 * space  查询区间天数限制
 * startRequired  开始时间是否必填
 * endRequired  结束时间是否必填
 * startMsg  开始时间为空错误提示
 * endMsg  结束时间为空错误提示
 * }
 */
export const checkSearchDates = (params, checkTimes) => {
  checkTimes.forEach(item => {
    let startTime = params[item.startTime];
    let endTime = params[item.endTime];
    const { msg, space, startRequired, endRequired, startMsg, endMsg } = item;
    if (startRequired && !startTime) {
      if (startMsg)
        ElMessage({
          message: $t(startMsg),
          type: 'warning'
        });
      throw Error($t(startMsg)); // 跳出当前循环
    }
    if (endRequired && !endTime) {
      if (endMsg)
        ElMessage({
          message: $t(endMsg),
          type: 'warning'
        });
      throw Error($t(endMsg)); // 跳出当前循环
    }
    if (startTime && endTime) {
      startTime = new Date(startTime).getTime();
      endTime = new Date(endTime).getTime();
      let erro = '';
      if (startTime > endTime) {
        erro = $t(msg);
        ElMessage({
          message: erro,
          type: 'warning'
        });
        throw Error(erro); // 跳出当前循环
      }
      if (space && typeof space === 'number') {
        const intervalLen = space * 24 * 3600 * 1000;
        if (endTime - startTime > intervalLen) {
          erro = `${$t('查询日期间隔不能超过')} ${space} ${$t('天')}`;
          // $t(`查询日期间隔不能超过${space}天`);
          ElMessage({
            message: erro,
            type: 'warning'
          });
          throw Error(erro); // 跳出当前循环
        }
      }
    }
  });
};

// 获取浏览器高度
export function getClientHeight() {
  return (
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight
  );
}

// 获取当天的开始与结束日期
export function GetTodayDate(addDate = 0, addTime = true) {
  const dd = new Date();
  dd.setDate(dd.getDate() + addDate); // 获取第addDate天后的日期
  const y = dd.getFullYear();
  const m =
    dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1; // 获取当前月份的日期，不足10补0
  const d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate(); // 获取当前几号，不足10补0
  let start = y + '-' + m + '-' + d;
  addTime ? (start = start + ' ' + '00:00:00') : '';
  let end = y + '-' + m + '-' + d;
  addTime ? (end = end + ' ' + '23:59:59') : '';
  return [start, end];
}

/**
 * 删除当前路由
 * @param {*} routeName 路由地址
 * @param {*} type 操作类型
 */
export function delView(routeName, type = 'filter') {
  return new Promise(resolve => {
    const delAliveRouteList = useMultiTagsStoreHook().handleTags(
      type,
      routeName
    );
    delAliveRouteList && delAliveRoutes(delAliveRouteList);
    resolve();
  });
}

// 获取当天日期的前7天日期
export function getBeforeDate(n, type = '-') {
  const d = new Date();
  let year = d.getFullYear();
  let mon = d.getMonth() + 1;
  let day = d.getDate();
  if (day <= n) {
    if (mon > 1) {
      mon = mon - 1;
    } else {
      year = year - 1;
      mon = 12;
    }
  }
  d.setDate(d.getDate() - n);
  year = d.getFullYear();
  mon = d.getMonth() + 1;
  day = d.getDate();
  const s =
    year +
    type +
    (mon < 10 ? '0' + mon : mon) +
    type +
    (day < 10 ? '0' + day : day);
  return s;
}

// 获取字段宽度
export function getColWidth(label) {
  const baseSize = 14;
  const padding = 50;
  const transferedLabel = $t(label);
  const str = transferedLabel.toString();
  const char = str.match(/[\u2E80-\u9FFF]/g);
  const num = str.match(/\d|\./g);
  const space = str.match(/\s+/g);
  const charLength = char ? char.length : 0;
  const numLength = num ? num.length : 0;
  const spaceLength = space ? space.length : 0;
  const otherLength = str.length - charLength - numLength - spaceLength;
  const totalWidth =
    charLength * baseSize * 1.25 +
    numLength * baseSize * 0.5 +
    otherLength * baseSize * 0.65 +
    spaceLength * 0.3 +
    padding;
  return totalWidth;
}

/**
 * 密码组合
 * 密码: 8-20位,必须包含字母、数字和特殊字符
 * @param {*} str 密码
 * @returns 返回true或false
 */
export const checkPwdZuhe = str => {
  const letter = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const number = '0123456789';
  const special = '~!@#$%^&*()[{]}-_=+|;:\'",<.>/?`';
  const arr = str.split('');
  const getIndex = (key, arrs) => {
    arrs.split('').findIndex(v => v === key);
  };
  const ret1 = arr.some(v => getIndex(v, letter) !== -1);
  const ret2 = arr.some(v => getIndex(v, number) !== -1);
  const ret3 = arr.some(v => getIndex(v, special) !== -1);
  return ret1 && ret2 && ret3 && str.length >= 8 && str.length <= 20;
};

/**
 * 密码连续
 * 密码: 8-20位,必须包含字母、数字和特殊字符
 * 校验密码不能出现3位及以上的连续数字或字母
 * @param {*} str 密码
 * @returns 返回true或false
 */
export const checkPwdRegx = str => {
  const arr = str.split('');
  let flag = true;
  const checkVal = value => {
    return /^[a-zA-Z0-9]$/.test(value);
  };
  for (let i = 1; i < arr.length - 1; i++) {
    const preVal = arr[i - 1];
    const nowVal = arr[i];
    const nextVal = arr[i + 1];
    const firstIndex = checkVal(preVal) ? preVal.charCodeAt() : '';
    const secondIndex = checkVal(nowVal) ? nowVal.charCodeAt() : '';
    const thirdIndex = checkVal(nextVal) ? nextVal.charCodeAt() : '';
    if (
      thirdIndex - secondIndex === 1 &&
      secondIndex - firstIndex === 1 &&
      firstIndex &&
      secondIndex &&
      thirdIndex
    ) {
      flag = false;
    }
  }
  return flag;
};

function conver(s) {
  return s < 10 ? '0' + s : s;
}

// 获取当前时间;
export function getCurDate() {
  const myDate = new Date();
  // 获取当前年
  const year = myDate.getFullYear();
  // 获取当前月
  const month = myDate.getMonth() + 1;
  // 获取当前日
  const date = myDate.getDate();
  const h = myDate.getHours(); // 获取当前小时数(0-23)
  const m = myDate.getMinutes(); // 获取当前分钟数(0-59)
  const s = myDate.getSeconds();
  // 获取当前时间
  const day = year + '-' + conver(month) + '-' + conver(date);
  const hour = conver(h) + ':' + conver(m) + ':' + conver(s);
  const now = day + ' ' + hour;
  return {
    dayHour: now,
    day,
    hour
  };
}

// 获取当前年月份
export function GetYearMonth(addDate = 0) {
  const dd = new Date();
  dd.setDate(dd.getDate() + addDate); // 获取第addDate天后的日期
  const y = dd.getFullYear();
  const m =
    dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1; // 获取当前月份的日期，不足10补0
  const start = y + '-' + m;
  const end = y + '-' + m;
  return [start, end];
}

// 下载文件
export function downLoadFile(data) {
  const elink = document.createElement('a');
  elink.style.display = 'none';
  elink.href = data;
  elink.setAttribute('download', '.xls');
  document.body.appendChild(elink);
  elink.click();
  URL.revokeObjectURL(elink.href);
  document.body.removeChild(elink);
  ElMessage.success($t('下载成功'));
}

// 转换为千分位
export function formatNumber(num) {
  return Number(num).toLocaleString('en', { useGrouping: true });
}

/**
 * 千分位处理
 * @param {*} value 转换的值
 * @param {*} keyName 参数名
 * @param {*} signName 页面显示参数名
 * @param {*} form 表单
 */
export function handleFormatFloatValue(value, keyName, signName, form) {
  if (!value) {
    form[signName] = '';
    form[keyName] = '';
    return;
  }
  const newValue = value.replace(/,/g, '');
  const newNums = String(newValue).split('.');
  const a1 = addCommasToNumber(newNums[0]);
  let xs = '';
  if (newNums.length === 2) {
    xs = '.' + newNums[1];
  } else if (newNums.length > 2) {
    xs = newNums
      .map((v, index) => {
        if (index !== 0) return v;
      })
      .join('.');
  }
  form[signName] = a1 + xs;
  form[keyName] = newValue;
  console.log('signName:' + form[signName], 'keyName:' + form[keyName]);
}
/**
 * 整数转换
 * @param {*} num 1234567890
 * @returns  输出: '1,234,567,890'
 */
function addCommasToNumber(num) {
  // 将数字转换为字符串，并匹配数字和小数点
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
